export default __webpack_public_path__ + "static/Entenda0099-9195f15b35e9c08978a5ec69c142b1b6.jpg";